import SoftLinks from 'components/Content/SoftLinks/SoftLinks';
import { withSoftLinksProps } from 'viewModel/content/softLinks/withSoftLinksProps';

export default withSoftLinksProps(SoftLinks);
